import React from 'react';
import '../App.css';

const Quote = () => (
  <>
    <section className="qoute">
      <h1>
        &quot;Mathematics is not about numbers, equations, computations, or
        algorithms: it is about understanding.&quot;
      </h1>
      <span className="author">- William Paul Thurston</span>
    </section>
  </>
);

export default Quote;
